import { ITEM_STATUS } from "@saleor/createOrChangeNotRefContract/constants";
import React from "react";

const useSelected = (rows, isChangeFlow) => {
  const [selected, setSelected] = React.useState<string[]>([]);

  const onSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      let newSelecteds = [];
      if (isChangeFlow) {
        newSelecteds = rows
          .filter(row => row?.itemStatusEn !== ITEM_STATUS.CANCEL)
          .map(n => n?.itemNo);
      } else {
        newSelecteds = rows
          .filter(row => !row?.parentItemNo)
          .map(n => n?.itemNo);
      }
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChildItemForSelect = (
    parent,
    selected,
    rows,
    newSelected,
    selectedIndex
  ) => {
    for (const row of rows) {
      if (
        row?.parentItemNo &&
        row?.parentItemNo === parent &&
        row?.itemStatusEn !== ITEM_STATUS.CANCEL
      ) {
        if (selectedIndex === -1 && !selected.includes(row.itemNo)) {
          newSelected = newSelected.concat(row.itemNo);
        } else if (selectedIndex > -1) {
          newSelected = newSelected.filter(item => item !== row.itemNo);
        }
      }
    }
    return newSelected;
  };

  const onSelect = (name: string) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected: string[] = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else {
      if (selectedIndex === 0) {
        newSelected = newSelected.concat(selected.slice(1));
      } else if (selectedIndex === selected.length - 1) {
        newSelected = newSelected.concat(selected.slice(0, -1));
      } else if (selectedIndex > 0) {
        newSelected = newSelected.concat(
          selected.slice(0, selectedIndex),
          selected.slice(selectedIndex + 1)
        );
      }
    }
    if (isChangeFlow) {
      const copiedRows = [...rows];
      copiedRows.sort((itemA: any, itemB: any) => itemA.itemNo - itemB.itemNo);
      newSelected = handleChildItemForSelect(
        name,
        selected,
        copiedRows,
        newSelected,
        selectedIndex
      );
    }
    setSelected(newSelected);
  };

  return {
    selected,
    onSelect,
    onSelectAll,
    setSelected
  };
};

export default useSelected;
